// extracted by mini-css-extract-plugin
export var numberInputContainer = "_78-0";
export var startPickingButton = "_78-1";